/* Same-origin handoff between the Builder and its native quote form. */
(function () {
  'use strict';

  var PREFIX = 'upsbBuilderQuoteTransferV1:';
  var VERSION = 1;
  var MAX_URL = 1800;
  var MAX_BODY = 8000;
  var LIFETIME = 2 * 60 * 60 * 1000;

  function previewThemeId() {
    // Shopify can remove the preview query before theme scripts run; only use
    // the rendered theme identity when it is explicitly unpublished.
    var theme = window.Shopify && window.Shopify.theme;
    function validId(value) {
      var id = String(value || '');
      return /^[1-9]\d{7,19}$/.test(id) && Number.isSafeInteger(Number(id)) ? id : '';
    }
    if (theme && theme.role && theme.role !== 'unpublished') return '';
    var queryId = new URLSearchParams(window.location.search).get('preview_theme_id');
    var renderedId = theme && theme.role === 'unpublished' ? validId(theme.id) : '';
    if (theme && theme.role === 'unpublished' && !renderedId) return '';
    if (validId(queryId) && (!renderedId || queryId === renderedId)) return queryId;
    return renderedId;
  }

  function target(base, key, value) {
    var url = new URL(base, window.location.origin);
    url.searchParams.delete('message');
    url.searchParams.delete('qt');
    url.searchParams.set(key, value);
    return url.pathname + url.search + url.hash;
  }

  function token() {
    if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') return '';
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function direct(base, message) {
    if (typeof message !== 'string' || !message.trim() || message.length > MAX_BODY) return '';
    var href = target(base, 'message', message);
    return href.length <= MAX_URL ? href : '';
  }

  // storageFirst (2 Oct 2026): the Builder sends every request by reference; without it, a short message still
  // travels in the URL (older callers).
  function prepare(base, message, locale, storageFirst) {
    if (typeof message !== 'string' || !message.trim()) return { error: 'empty' };
    if (message.length > MAX_BODY) return { error: 'too_long' };
    var href = storageFirst ? '' : direct(base, message);
    if (href) return { href: href, mode: 'url' };
    if (locale !== 'en' && locale !== 'fr') return { error: 'locale' };
    var id = token();
    if (!id) return { error: 'storage' };
    var now = Date.now();
    var record = JSON.stringify({ version: VERSION, created: now,
      expires: now + LIFETIME, locale: locale, message: message });
    try {
      window.localStorage.setItem(PREFIX + id, record);
      if (window.localStorage.getItem(PREFIX + id) !== record) return { error: 'storage' };
    } catch (error) {
      return { error: 'storage' };
    }
    return { href: target(base, 'qt', id), mode: 'storage' };
  }

  function resolve(id, locale) {
    if (!/^[a-f0-9]{32}$/.test(id || '')) return { error: 'invalid' };
    var raw;
    try { raw = window.localStorage.getItem(PREFIX + id); }
    catch (error) { return { error: 'storage' }; }
    if (!raw) return { error: 'missing' };
    try {
      var value = JSON.parse(raw);
      if (!value || value.version !== VERSION || typeof value.message !== 'string' ||
          !value.message.trim() || value.message.length > MAX_BODY ||
          !Number.isSafeInteger(value.created) || !Number.isSafeInteger(value.expires) ||
          value.expires !== value.created + LIFETIME || value.created > Date.now() + 60000) {
        return { error: 'invalid' };
      }
      if (value.expires <= Date.now()) return { error: 'expired' };
      if (value.locale !== locale) return { error: 'locale' };
      return { message: value.message, mode: 'storage' };
    } catch (error) {
      return { error: 'invalid' };
    }
  }

  window.UPSBQuoteTransfer = { direct: direct, prepare: prepare, resolve: resolve,
    previewThemeId: previewThemeId,
    maxBody: MAX_BODY, maxUrl: MAX_URL };
})();
